import { Component, OnInit } from '@angular/core';
import { NewPageService } from '../../templates/new-page/service/new-page.service';
import { NewPageList } from '../../core/models/new-page-list';
import { element } from 'protractor';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.css'],
  providers: [NewPageService]
})
export class CardsComponent implements OnInit {

  constructor(private newPageService: NewPageService, private confirmationService: ConfirmationService) {
    this.newPageService.validate$.subscribe(validate => {
      if (validate) {
        this.validate();
      }
    });
  }

  aboutUs: NewPageList;

  classArray = new Array<string>();

  eventCard: boolean = true;

  ngOnInit() {
    if (this.aboutUs.listItems.length < 1) {
      this.addItem();
    }
  }

  _ref: any;

  confirmDelete() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete ?',
      accept: () => {
        this.remove();
      }
    });
  }

  remove() {
    this.newPageService.removeItem(this.aboutUs);
    this._ref.destroy();
  }

  upItem() {
    this.newPageService.upItem(this.aboutUs);
  }

  downItem() {
    this.newPageService.downItem(this.aboutUs);
  }

  addItem() {
    this.aboutUs.listItems.push('');
    this.classArray.push('');
  }
  removeItem(index) {
    if (this.aboutUs.listItems.length > 1) {
      this.aboutUs.listItems = this.aboutUs.listItems.filter((val, i) => i != index);
      this.classArray = this.classArray.filter((val, i) => i != index)
    }
  }
  validate() {
    let index = 0;
    this.aboutUs.listItems.forEach(element => {
      if (element == null || element.trim().length < 1) {
        this.classArray[index] = 'fieldWithErrors';
      } else {
        this.classArray[index] = '';
      }
      index++;
    });
  }
  trackByIndex(index: number, value: number) {
    return index;
  }
}



// WEBPACK FOOTER //
// /app/src/app/layout/cards/cards.component.ts